/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'

interface LeadTagsSelectedListProps {
    tags: string[]
    onRemove: (tag: string) => void
}

const LeadTagsSelectedList = (props: LeadTagsSelectedListProps) => {
    if (!props.tags.length) {
        return null
    }

    return (
        <div className="LeadTagsSelectedList">
            {props.tags.map((tag) => (
                <span
                    key={tag}
                    className="inline-flex items-center gap-x-0.5 rounded-md bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-700/10 dark:bg-indigo-400/10 dark:text-indigo-400 dark:ring-indigo-400/30"
                >
                    {tag}
                    <button
                        type="button"
                        onClick={() => props.onRemove(tag)}
                        className="group relative -mr-1 h-3.5 w-3.5 rounded-sm hover:bg-indigo-600/20"
                    >
                        <XMarkIcon className="h-3.5 w-3.5 stroke-indigo-600/50 group-hover:stroke-indigo-600 dark:stroke-indigo-400/50 dark:group-hover:stroke-indigo-400" />
                    </button>
                </span>
            ))}
        </div>
    )
}

export default LeadTagsSelectedList
